export const auditHeaders = [
  {
    text: "Match Date",
    value: "updated_at"
  },
  {
    text: "Loc. Code",
    value: "facility.location_code"
  },
  {
    text: "Deal Name",
    value: "customer_last_name"
  },
  {
    text: "Deal Email",
    value: "customer_email"
  },
  {
    text: "Deal Phone",
    value: "customer_phone"
  },
  {
    text: "Tenant ID",
    value: "tenant_id"
  },
  {
    text: "Name Match",
    value: "match"
  },
  {
    text: "Email Match",
    value: "match"
  },
  {
    text: "Phone Match",
    value: "match"
  },
  {
    text: "Match Tenant ID",
    value: "matched_tenant_id" // tenant id on match
  },
  {
    text: "Actions...",
    value: null,
    sortable: false
  }
];
